/* G&G Author Projects JS. Renders the author's submissions as a portfolio grid
   with status tabs, plus email preferences.
   GET /apps/proxy/api/storefront/authors/submissions */
(function () {
  'use strict';
  try { console.log('[aprj] author-projects.js v2026-06-17-draft-thumb'); } catch (e) {}

  // Thumbnails: Shopify CDN images resize via ?width=. B2-backed previews are
  // routed through our cached resize proxy (returns a small webp) so the grid
  // loads fast instead of pulling full-resolution originals.
  function cdnThumb(url, w) {
    if (!url) return url;
    if (url.indexOf('cdn.shopify.com') > -1 || url.indexOf('/cdn/shop/') > -1) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    if (url.indexOf('backblazeb2.com') > -1) {
      return '/apps/proxy/api/storefront/authors/thumb?w=' + w + '&u=' + encodeURIComponent(url);
    }
    return url;
  }

  function el(tag, opts) {
    var n = document.createElement(tag);
    if (opts) {
      if (opts.className) n.className = opts.className;
      if (opts.text != null) n.textContent = String(opts.text);
      if (opts.attrs) Object.keys(opts.attrs).forEach(function (k) { n.setAttribute(k, opts.attrs[k]); });
    }
    return n;
  }
  function fmtMoney(n, currency) {
    if (n == null) return '';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(n); }
    catch (e) { return n + ' ' + (currency || ''); }
  }
  // BUSINESS dates are rendered in the SHOP's time zone, never the viewer's.
  //
  // A bare toLocaleDateString() formats in whatever zone the browser sits in,
  // so the same sale showed one day to someone in Kyiv, another in the Shopify
  // admin (which is always shop time) and a third to a buyer in California.
  // The zone travels down in the API payload; until the first response lands we
  // fall back to the viewer's, which is the old behaviour and never worse.
  var SHOP_TZ = null;
  function setShopTz(tz) { if (tz) SHOP_TZ = tz; }
  function dateOpts(o) {
    var out = {};
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = o[k];
    if (SHOP_TZ) out.timeZone = SHOP_TZ;
    return out;
  }
  function fmtDate(iso) { try { return new Date(iso).toLocaleDateString(undefined, dateOpts({})); } catch (e) { return iso; } }

  function init(root) {
    var inner = root.querySelector('.aprj-inner');
    if (!inner) return;
    var isPreview = root.dataset.aprjPreview === '1';
    if (!isPreview && inner.getAttribute('data-aprj-is-author') !== '1') return;

    var currency = inner.getAttribute('data-aprj-currency') || 'USD';
    var editUrl = inner.getAttribute('data-aprj-edit-url') || '';
    var editLabel = inner.getAttribute('data-aprj-edit-label') || 'Edit';
    var viewLabel = inner.getAttribute('data-aprj-view-label') || 'View';
    var els = {
      grid: inner.querySelector('[data-aprj-grid]'),
      empty: inner.querySelector('[data-aprj-empty]'),
      tabs: inner.querySelectorAll('[data-aprj-tab]'),
      prefsCard: inner.querySelector('[data-aprj-prefs]'),
      prefInputs: inner.querySelectorAll('[data-aprj-pref]'),
      prefsMsg: inner.querySelector('[data-aprj-prefs-msg]'),
    };

    var all = [];
    var filter = 'all';
    var sortBy = 'newest';
    var typeFilter = 'all';
    var loadError = false;
    var page = 1;
    var PAGE_SIZE = 20;
    var pager = null;

    var BADGE = { pending: 'Under review', approved: 'Selling', rejected: 'Needs changes', draft: 'Draft' };

    function card(s) {
      var c = el('div', { className: 'aprj-proj' });
      var media = el('div', { className: 'aprj-proj-media' });
      if (s.imageUrl) { var img = document.createElement('img'); img.src = cdnThumb(s.imageUrl, 600); img.alt = s.title; img.loading = 'lazy'; img.decoding = 'async'; media.appendChild(img); }
      else media.appendChild(el('span', { className: 'aprj-proj-media-empty', text: (s.previewCount || 0) + ' preview(s)' }));
      media.appendChild(el('span', { className: 'aprj-proj-badge aprj-proj-badge--' + s.status, text: BADGE[s.status] || s.status }));
      c.appendChild(media);

      var body = el('div', { className: 'aprj-proj-body' });
      var title = el('div', { className: 'aprj-proj-title' });
      if (s.status === 'approved' && s.productHandle) {
        title.appendChild(el('a', { text: s.title, attrs: { href: '/products/' + s.productHandle } }));
      } else { title.textContent = s.title; }
      body.appendChild(title);

      var metaParts = [];
      if (s.productType) metaParts.push(s.productType);
      // Only show a date when we actually have one. Team-published products
      // have no submission date - skip it (avoids the 1970 epoch fallback).
      if (s.createdAt) metaParts.push(fmtDate(s.createdAt));
      if (s.deliverableCount) metaParts.push(s.deliverableCount + ' sale file' + (s.deliverableCount === 1 ? '' : 's'));
      if (metaParts.length) body.appendChild(el('div', { className: 'aprj-proj-meta', text: metaParts.join(' · ') }));

      if (s.proposedPrice != null) {
        var priceText = (s.proposedPrice === 0)
          ? 'Free'
          : ((s.licenseCount > 1 ? 'from ' : '') + fmtMoney(s.proposedPrice, s.currency || currency));
        body.appendChild(el('div', { className: 'aprj-proj-price', text: priceText }));
      }
      if (s.status === 'rejected' && s.reviewNote) body.appendChild(el('div', { className: 'aprj-proj-note', text: s.reviewNote }));

      // Footer = divider + stats (always shows sales count, even 0, + earnings)
      // + actions. Pushed to the bottom so cards line up regardless of height.
      var footer = el('div', { className: 'aprj-proj-footer' });

      var stats = el('div', { className: 'aprj-proj-stats' });
      var sc = s.salesCount || 0;
      var dl = s.downloads || 0;
      // Free products report DOWNLOADS (both gated freebies + $0 acquisitions),
      // not "0 sales". Treat price 0 as free; for read-only works with no price
      // and no earnings, fall back to downloads when there are any.
      var freeish = (s.proposedPrice === 0) || (s.proposedPrice == null && (s.earned || 0) === 0 && dl > 0);
      if (freeish) {
        stats.appendChild(el('span', { text: dl + ' ' + (dl === 1 ? 'download' : 'downloads') }));
      } else {
        stats.appendChild(el('span', { text: sc + ' ' + (sc === 1 ? 'sale' : 'sales') }));
      }
      if (s.earned != null && (s.status === 'approved' || s.earned > 0)) {
        stats.appendChild(el('span', { className: 'aprj-proj-earned', text: 'Earned ' + fmtMoney(s.earned, s.currency || currency) }));
      }
      footer.appendChild(stats);

      // Actions: Edit (only the author's own submissions) + View (when live).
      var actions = el('div', { className: 'aprj-proj-actions' });
      var editId = s.submissionId || (s.editable ? s.id : null);
      if (editUrl && s.editable && editId) {
        actions.appendChild(el('a', {
          className: 'aprj-proj-btn aprj-proj-edit',
          text: editLabel,
          attrs: { href: editUrl + (editUrl.indexOf('?') > -1 ? '&' : '?') + 'id=' + encodeURIComponent(editId) },
        }));
      }
      if (s.status === 'approved' && s.productHandle) {
        actions.appendChild(el('a', {
          className: 'aprj-proj-btn aprj-proj-view',
          text: viewLabel,
          attrs: { href: '/products/' + s.productHandle },
        }));
      }
      if (actions.childElementCount) footer.appendChild(actions);

      body.appendChild(footer);
      c.appendChild(body);
      return c;
    }

    function render() {
      els.grid.innerHTML = '';
      // Load failure must NOT look like "no products" (that reads as data loss).
      if (loadError) {
        els.grid.hidden = true;
        if (pager) pager.hidden = true;
        if (els.empty) {
          els.empty.hidden = false;
          var ep = els.empty.querySelector('p');
          if (ep) ep.textContent = 'Couldn’t load your products. Please refresh the page and try again.';
        }
        return;
      }
      var items = all.slice();
      if (filter !== 'all') items = items.filter(function (s) { return s.status === filter; });
      if (typeFilter !== 'all') items = items.filter(function (s) { return (s.productType || '') === typeFilter; });
      items = sortItems(items);
      if (!items.length) {
        if (els.empty) els.empty.hidden = false;
        els.grid.hidden = true;
        if (pager) pager.hidden = true;
        return;
      }
      els.grid.hidden = false;
      if (els.empty) els.empty.hidden = true;
      var totalPages = Math.max(1, Math.ceil(items.length / PAGE_SIZE));
      if (page > totalPages) page = totalPages;
      if (page < 1) page = 1;
      var start = (page - 1) * PAGE_SIZE;
      items.slice(start, start + PAGE_SIZE).forEach(function (s) { els.grid.appendChild(card(s)); });
      renderPager(totalPages, items.length);
    }

    // Pager styled identically to the Earnings "Earnings by product" pager:
    // "Showing X–Y of Z" on the left, numbered nav with ellipsis on the right.
    function renderPager(totalPages, totalItems) {
      if (!pager) return;
      pager.innerHTML = '';
      if (totalPages <= 1) { pager.hidden = true; return; }
      pager.hidden = false;

      function go(p) {
        page = p; render();
        if (els.grid && els.grid.scrollIntoView) { try { els.grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { els.grid.scrollIntoView(); } }
      }

      var start = (page - 1) * PAGE_SIZE;
      pager.appendChild(el('span', {
        className: 'aprj-pager-info',
        text: 'Showing ' + (start + 1) + '–' + Math.min(start + PAGE_SIZE, totalItems) + ' of ' + totalItems,
      }));

      var nav = el('div', { className: 'aprj-pager-nav' });
      function mkBtn(label, target, opts) {
        opts = opts || {};
        var b = el('button', { className: 'aprj-pager-btn' + (opts.active ? ' is-active' : ''), text: label, attrs: { type: 'button' } });
        if (opts.disabled) b.disabled = true;
        else if (target != null) b.addEventListener('click', function () { go(target); });
        if (opts.active) b.setAttribute('aria-current', 'page');
        return b;
      }
      nav.appendChild(mkBtn('‹', page - 1, { disabled: page === 1 }));
      var pages = [];
      for (var i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) pages.push(i);
        else if (pages[pages.length - 1] !== '...') pages.push('...');
      }
      pages.forEach(function (p) {
        if (p === '...') nav.appendChild(el('span', { className: 'aprj-pager-ellipsis', text: '…' }));
        else nav.appendChild(mkBtn(String(p), p, { active: p === page }));
      });
      nav.appendChild(mkBtn('›', page + 1, { disabled: page === totalPages }));
      pager.appendChild(nav);
    }

    function updateCounts() {
      ['approved', 'pending', 'rejected', 'draft'].forEach(function (st) {
        var node = inner.querySelector('[data-aprj-count="' + st + '"]');
        if (node) { var n = all.filter(function (s) { return s.status === st; }).length; node.textContent = n ? n : ''; }
      });
    }

    // --- Sort + type filter (styled like the author-works pills + dropdown) ---
    // Only sorts that are reliable for EVERY item: team-published works have
    // no price, so price sorts were dropped (they no-op'd and read as broken).
    var SORTS = [['newest', 'Newest'], ['oldest', 'Oldest'], ['earned', 'Top earning'], ['sales', 'Most sales'], ['title', 'Title A–Z']];
    function ts(s) { return s.createdAt ? new Date(s.createdAt).getTime() : 0; }
    function sortItems(arr) {
      var a = arr.slice();
      switch (sortBy) {
        case 'oldest': a.sort(function (x, y) { return ts(x) - ts(y); }); break;
        case 'earned': a.sort(function (x, y) { return (y.earned || 0) - (x.earned || 0); }); break;
        case 'sales': a.sort(function (x, y) { return (y.salesCount || 0) - (x.salesCount || 0); }); break;
        case 'title': a.sort(function (x, y) { return String(x.title || '').localeCompare(String(y.title || '')); }); break;
        default: a.sort(function (x, y) { return ts(y) - ts(x); }); // newest
      }
      return a;
    }

    function svgEl(markup) { var d = document.createElement('div'); d.innerHTML = markup; return d.firstChild; }
    var pillsHost = null;
    function buildControls() {
      var bar = el('div', { className: 'aprj-controls' });

      // Type filter pills (auto-discovered from the data, with counts).
      pillsHost = el('div', { className: 'aprj-pills', attrs: { role: 'tablist', 'aria-label': 'Filter by type' } });
      bar.appendChild(pillsHost);

      // Sort: custom dropdown matching author-works.
      var dd = el('div', { className: 'aprj-sort' });
      var trigger = el('button', { className: 'aprj-sort-trigger', attrs: { type: 'button', 'aria-haspopup': 'listbox', 'aria-expanded': 'false' } });
      trigger.appendChild(svgEl('<svg class="aprj-sort-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="3" y1="6" x2="21" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/></svg>'));
      var current = SORTS.filter(function (o) { return o[0] === sortBy; })[0] || SORTS[0];
      var valSpan = el('span', { className: 'aprj-sort-value', text: current[1] });
      trigger.appendChild(valSpan);
      trigger.appendChild(svgEl('<svg class="aprj-sort-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'));

      var menu = el('div', { className: 'aprj-sort-menu', attrs: { role: 'listbox' } });
      SORTS.forEach(function (o) {
        var opt = el('button', { className: 'aprj-sort-option' + (o[0] === sortBy ? ' active' : ''), text: o[1], attrs: { type: 'button', role: 'option', 'data-value': o[0] } });
        opt.addEventListener('click', function () {
          sortBy = o[0]; valSpan.textContent = o[1];
          menu.querySelectorAll('.aprj-sort-option').forEach(function (x) { x.classList.toggle('active', x === opt); });
          dd.classList.remove('open'); trigger.setAttribute('aria-expanded', 'false');
          page = 1; render();
        });
        menu.appendChild(opt);
      });
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = dd.classList.toggle('open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!dd.contains(e.target)) { dd.classList.remove('open'); trigger.setAttribute('aria-expanded', 'false'); }
      });
      dd.appendChild(trigger); dd.appendChild(menu);
      bar.appendChild(dd);
      return bar;
    }

    function setType(t) {
      typeFilter = t; page = 1;
      if (pillsHost) pillsHost.querySelectorAll('.aprj-pill').forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-type') === t); });
      render();
    }

    // Build the type-filter pills from the distinct productTypes in the data.
    // Hidden entirely when no item carries a type (nothing to filter by).
    function updateTypePills() {
      if (!pillsHost) return;
      var counts = {};
      all.forEach(function (s) { var t = s.productType || ''; if (t) counts[t] = (counts[t] || 0) + 1; });
      var keys = Object.keys(counts).sort();
      if (typeFilter !== 'all' && !counts[typeFilter]) typeFilter = 'all';
      pillsHost.innerHTML = '';
      pillsHost.style.display = keys.length ? '' : 'none';
      if (!keys.length) return;

      function pill(value, label, count) {
        var b = el('button', { className: 'aprj-pill' + (typeFilter === value ? ' is-active' : ''), attrs: { type: 'button', role: 'tab', 'data-type': value } });
        b.appendChild(document.createTextNode(label + ' '));
        b.appendChild(el('span', { className: 'aprj-pill-count', text: String(count) }));
        b.addEventListener('click', function () { setType(value); });
        return b;
      }
      pillsHost.appendChild(pill('all', 'All', all.length));
      keys.forEach(function (t) { pillsHost.appendChild(pill(t, t, counts[t])); });
    }

    // Tablist semantics for screen readers.
    var tabsHost = inner.querySelector('[data-aprj-tabs]');
    if (tabsHost) tabsHost.setAttribute('role', 'tablist');
    els.tabs.forEach(function (t) {
      t.setAttribute('role', 'tab');
      t.setAttribute('aria-selected', t.classList.contains('is-active') ? 'true' : 'false');
      t.addEventListener('click', function () {
        filter = t.getAttribute('data-aprj-tab') || 'all';
        page = 1;
        els.tabs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        render();
      });
    });

    // Sort + type controls above the grid.
    if (els.grid && els.grid.parentNode) {
      els.grid.parentNode.insertBefore(buildControls(), els.grid);
    }

    // Pagination control under the grid (20 per page).
    if (els.grid && els.grid.parentNode) {
      pager = el('div', { className: 'aprj-pager' });
      pager.setAttribute('data-aprj-pager', '');
      pager.hidden = true;
      els.grid.parentNode.insertBefore(pager, els.grid.nextSibling);
    }

    function renderSkeletons(n) {
      if (!els.grid) return;
      els.grid.hidden = false;
      if (els.empty) els.empty.hidden = true;
      els.grid.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var sk = el('div', { className: 'aprj-proj aprj-skel' });
        sk.appendChild(el('div', { className: 'aprj-proj-media aprj-skel-box' }));
        var b = el('div', { className: 'aprj-proj-body' });
        b.appendChild(el('div', { className: 'aprj-skel-line' }));
        b.appendChild(el('div', { className: 'aprj-skel-line aprj-skel-line--short' }));
        sk.appendChild(b);
        els.grid.appendChild(sk);
      }
    }

    function load() {
      if (isPreview) { all = mockData(); updateCounts(); updateTypePills(); render(); return; }
      renderSkeletons(6);
      fetch('/apps/proxy/api/storefront/authors/submissions', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) { setShopTz(j && j.timeZone); all = j.submissions || []; loadError = false; updateCounts(); updateTypePills(); render(); })
        .catch(function () { loadError = true; render(); });
    }

    function mockData() {
      var now = Date.now();
      return [
        { id: 'm1', submissionId: 'm1', editable: true, earned: 142.5, salesCount: 6, title: 'Paper Box Mockup - High Angle', status: 'approved', productType: 'Mockups', proposedPrice: 24.99, licenseCount: 3, currency: currency, previewCount: 3, deliverableCount: 2, imageUrl: null, productHandle: 'demo', createdAt: new Date(now - 86400000 * 5).toISOString(), reviewNote: null },
        { id: 'm2', submissionId: 'm2', editable: true, earned: 0, salesCount: 0, title: 'Coffee Cup Mockup - Front', status: 'pending', productType: 'Mockups', proposedPrice: 19.0, licenseCount: 3, currency: currency, previewCount: 2, deliverableCount: 1, imageUrl: null, productHandle: null, createdAt: new Date(now - 86400000 * 1).toISOString(), reviewNote: null },
        { id: 'm3', submissionId: null, editable: false, earned: 88.0, salesCount: 4, title: 'Team Collab Bundle (published by us)', status: 'approved', productType: null, proposedPrice: null, licenseCount: 0, currency: currency, previewCount: 1, deliverableCount: 0, imageUrl: null, productHandle: 'demo', createdAt: null, reviewNote: null },
      ];
    }

    // ---- Email preferences ----
    function loadPrefs() {
      if (!els.prefsCard || !els.prefInputs.length) return;
      if (isPreview) { els.prefsCard.hidden = false; els.prefInputs.forEach(function (i) { i.checked = true; }); return; }
      fetch('/apps/proxy/api/storefront/authors/profile', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var a = j.author || {};
          els.prefsCard.hidden = false;
          els.prefInputs.forEach(function (i) { i.checked = a[i.getAttribute('data-aprj-pref')] !== false; });
        })
        .catch(function () { /* leave hidden */ });
    }
    function savePrefs() {
      if (isPreview) { if (els.prefsMsg) els.prefsMsg.textContent = 'Preview mode - not saved.'; return; }
      var body = {};
      els.prefInputs.forEach(function (i) { body[i.getAttribute('data-aprj-pref')] = i.checked; });
      if (els.prefsMsg) { els.prefsMsg.textContent = 'Saving...'; els.prefsMsg.className = 'aprj-prefs-msg'; }
      fetch('/apps/proxy/api/storefront/authors/profile', {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body),
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (resp) {
          if (els.prefsMsg) {
            els.prefsMsg.textContent = resp.ok ? 'Saved.' : ((resp.json && resp.json.error) || 'Could not save.');
            els.prefsMsg.className = 'aprj-prefs-msg ' + (resp.ok ? 'is-success' : 'is-error');
          }
        })
        .catch(function () { if (els.prefsMsg) { els.prefsMsg.textContent = 'Could not save.'; els.prefsMsg.className = 'aprj-prefs-msg is-error'; } });
    }
    els.prefInputs.forEach(function (i) { i.addEventListener('change', savePrefs); });

    load();
    loadPrefs();
  }

  function boot() {
    document.querySelectorAll('.aprj-wrapper').forEach(function (root) {
      if (root.dataset.aprjInit === '1') return;
      root.dataset.aprjInit = '1';
      init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
